/**
 * Small stat widgets for the reports page.
 */
export const todayISO = () => new Date().toISOString().slice(0, 10);


export function Stat({ label, value, testid, tone }) {
  return (
    <div className="border border-zinc-200 p-4" data-testid={testid}>
      <div className="overline">{label}</div>
      <div
        className={`text-2xl font-bold mt-1 ${tone === "green" ? "text-emerald-600" : "text-ink"}`}
      >
        {value}
      </div>
    </div>
  );
}


export function DefBox({ label, value, color = "#1E4FCC", sub }) {
  return (
    <div className="p-3 border border-zinc-200 bg-white">
      <div className="text-[10px] uppercase tracking-wide text-muted2 font-semibold">
        {label}
      </div>
      <div className="text-2xl font-bold tabular-nums mt-1" style={{ color }}>
        {value}
      </div>
      {sub && <div className="text-[10px] text-muted2 mt-0.5">{sub}</div>}
    </div>
  );
}
